<template>
    <div>
        <el-form size="mini" :model="form" :rules="rules" ref="form" label-width="100px" style="width: 600px;">
            <el-form-item label="视频名称" prop="videoName">
                <el-input v-model="form.videoName" placeholder="请输入视频名称"></el-input>
            </el-form-item>
            <el-form-item label="类型" prop="productType">
                <el-select v-model="form.productType" placeholder="请选择类型">
                    <el-option label="EVO" value="EVO"></el-option>
                    <el-option label="FP10" value="FP10"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="封面图" prop="videoCover">
                <uploader v-model="form.videoCover"></uploader>
            </el-form-item>
            <el-form-item label="权重" prop="weight">
                <el-input v-model="form.weight" placeholder="请输入权重"></el-input>
            </el-form-item>
            <el-form-item label="视频附件" prop="videoUrl">
                <uploader-video v-model="form.videoUrl"></uploader-video>
            </el-form-item>
            <el-form-item>
                <el-button size="mini" type="primary" @click="handleSubmit">保存</el-button>
                <el-button size="mini" @click="handleCancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { detail, edit, add } from "@/api/content/tutorial";
import UploaderVideo from "@/components/UploaderVideo.vue";
import Uploader from "@/components/Uploader.vue";
export default {
    components: { UploaderVideo, Uploader },
    data() {
        return {
            form: {
                videoName: '',
                productType: '',
                weight: '',
                videoCover: '',
                videoUrl: ''
            },
            rules: {
                videoName: [{ required: true, message: '请输入视频名称', trigger: 'blur' }],
                productType: [{ required: true, message: '请选择类型', trigger: 'change' }],
                videoCover: [{ required: true, message: '请上传封面图', trigger: 'blur' }],
                weight: [{ required: true, message: '请输入权重', trigger: 'blur' }],
                videoUrl: [{ required: true, message: '请上传视频', trigger: 'blur' }]
            }
        }
    },
    mounted() {
        if (this.$route.query.id) {
            this.getDetail(this.$route.query.id);
        }
    },
    methods: {
        getDetail(id) {
            detail({ id }).then(({ code, result, message }) => {
                if (code == 200) {
                    this.form = result;
                } else {
                    this.$message.error(message);
                }
            });
        },
        handleSubmit() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                if (this.form.id) {
                    edit(this.form).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success('保存成功');
                            this.$router.back();
                        } else {
                            this.$message.error(message);
                        }
                    });
                } else {
                    add(this.form).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success('保存成功');
                            this.$router.back();
                        } else {
                            this.$message.error(message);
                        }
                    });
                }
            })
        },
        handleCancel() {
            this.$router.back();
        }
    }
}
</script>

<style></style>
